export default "__VITE_PUBLIC_ASSET__964fca95__"